import { TLanguage } from 'contexts/app-context/types'

type TTERMS_WITH_URL_SOURCE = 'privacyPolicyBR' // | privacyPolicyUS

const TERMS_URL: Record<TLanguage, Record<TTERMS_WITH_URL_SOURCE, string>> = {
  'pt-BR': {
    privacyPolicyBR: 'https://inter.co/politica-de-privacidade/privacidade/',
    // privacyPolicyUS: 'https://us.inter.co/pt/compliance?pagina-de-privacidade',
  },
  'en-US': {
    privacyPolicyBR: 'https://inter.co/politica-de-privacidade/privacidade/',
    // privacyPolicyUS: 'https://us.inter.co/compliance?privacy-portal',
  },
  'es-ES': {
    privacyPolicyBR: 'https://inter.co/politica-de-privacidade/privacidade/',
    // privacyPolicyUS: 'https://us.inter.co/es/compliance?pagina-de-privacidad',
  },
}

export { TERMS_URL }
export type { TTERMS_WITH_URL_SOURCE }
